//custom styles for Compare app
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutationsList, observer) => {
    // Look for sc-add-to-compare elements instead
    const compareElements = document.querySelectorAll("sc-add-to-compare");

    if (compareElements.length > 0) {
      compareElements.forEach((element) => {
        // Check if shadow root exists and hasn't been styled yet
        if (element.shadowRoot && !element.hasAttribute("data-styled")) {
          const shadow = element.shadowRoot;
          const sheet = new CSSStyleSheet();

          // Styles for labels (remove .checkbox-control prefix since we're inside shadow DOM)
          sheet.insertRule(`
            span[part="checkbox-label"] {
              font-size: 0; 
            }
          `);

          sheet.insertRule(`
            span[part="checkbox-label"]::before {
                content: "Compare";
                font-size: 1rem;
            }
          `);

          sheet.insertRule(`
            @media (max-width: 1023px) {
              span[part="checkbox-label"]::before {
                    font-size: .8rem !important;
                }
              }
            `);

          sheet.insertRule(`
            input[part="checkbox-input"] {
                appearance: none !important;
                -webkit-appearance: none !important;
                -moz-appearance: none !important;
                border-radius: 50% !important;
                border: 1px solid #000000 !important;
                border-style: solid !important;
                background-color: transparent !important;
                cursor: pointer;
                position: relative !important;
                width: 15px !important;
                height: 15px !important;
            }
          `);

          sheet.insertRule(`
           @media (max-width:1023px){
            input[part="checkbox-input"] {
                width: 12px !important;
                height: 12px !important;
            }
            }
          `);

          // Add checked state
          sheet.insertRule(`
            input[part="checkbox-input"]:checked {
                background-color: #000000 !important;
                border-color: #000000 !important;
            }
          `);

          // Add inner dot when checked
          sheet.insertRule(`
            input[part="checkbox-input"]:checked::after {
                content: '' !important;
                position: absolute !important;
                top: 50% !important;
                left: 50% !important;
                transform: translate(-50%, -50%) !important;
                width: 15px !important;
                height: 15px !important;
                background-color: #000000 !important;
                border-radius: 50% !important;
            }
          `);

          shadow.adoptedStyleSheets = [sheet];

          element.setAttribute("data-styled", "true");
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// External Links to Open in New Tab
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}
